import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DragDropContext } from "react-beautiful-dnd";
import { Col } from 'react-bootstrap';
import { handleDragDrop } from '../../../actions/eg-kanban';
import Columns from '../Column/Columns';
import EquipmentColumns from '../Equipment/EquipmentColumns';
import { EG_OPTION_TYPES } from '../../../constants';

const BoardBody = (props) => {
    const [draggableType, setDraggableTtype] = useState("");

    const dragStart = (e) => {
        const draggableType = EG_OPTION_TYPES.indexOf(e.source.droppableId) >= 0 ? e.source.droppableId : EG_OPTION_TYPES[e.source.index];
        setDraggableTtype(draggableType);
    }

    const dragEnd = result => {
        setDraggableTtype("");
        const { source, destination, draggableId } = result;
        if (!destination) return;

        let params = {};

        //source and destination not the type of options
        if (EG_OPTION_TYPES.indexOf(source.droppableId) < 0 && EG_OPTION_TYPES.indexOf(destination.droppableId) < 0) {
            if (source.droppableId === destination.droppableId) return;

            params = {
                sourceIndex: source.index,
                sourceId: source.droppableId,
                destIndex: source.index,
                destId: destination.droppableId,
                draggableId
            }
        }

        //only source is the type of options
        if (EG_OPTION_TYPES.indexOf(source.droppableId) >= 0) {
            params = {
                ...params,
                sourceIndex: source.index,
                sourceId: source.droppableId,
                draggableId
            };

            if (EG_OPTION_TYPES.indexOf(destination.droppableId) < 0) {
                params = {
                    ...params,
                    destIndex: EG_OPTION_TYPES.indexOf(source.droppableId),
                    destId: destination.droppableId
                };
            }
        }

        //only destination is the type of options
        if (EG_OPTION_TYPES.indexOf(destination.droppableId) >= 0) {
            params = {
                ...params,
                sourceIndex: source.index,
                sourceId: source.droppableId,
                destIndex: destination.index,
                destId: destination.droppableId,
                draggableId
            };

            if (EG_OPTION_TYPES.indexOf(source.droppableId) < 0) {
                params = {
                    ...params,
                    destIndex: destination.index,
                    destId: destination.droppableId
                };
            }
        }

        props.actions.handleDragDrop(params);
    };

    return (
        <DragDropContext onDragStart={dragStart} onDragEnd={dragEnd}>
            <div className="kanban-body row" >
                <Col lg={8} md={8} sm={8} className="p-0">
                    <Columns farmId={props.farmId} draggableType={draggableType} />
                </Col>
                <Col lg={4} md={4} sm={4} className="p-0">
                    <EquipmentColumns farmId={props.farmId} draggableType={draggableType} />
                </Col>
            </div>
        </DragDropContext>
    )
};


const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        handleDragDrop
    }, dispatch)
});

export default connect(null, mapDispatchToProps)(BoardBody);